import { makeContext } from "../make";

type ICoords = [number, number];
export const {
  Context: CoordsContext,
  useContext: useCoordsContext,
  Provider: CoordsProvider,
} = makeContext<ICoords | null>("Coords", null);
